import { render } from "./ParamOptimizer.vue?vue&type=template&id=aae797aa"
import script from "./ParamOptimizer.vue?vue&type=script&lang=js"
export * from "./ParamOptimizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__